<template>
  <li class="note-wrapper" @click="onItemClick">
    <div class="top">
      <span class="top__name">{{ noteItem.customerName || '未完善姓名' }}</span><span class="top__time">{{noteItem.latestVisitedAt}}</span>
    </div>
    <span class="number">{{ noteItem.customerMobile || '未完善手机号' }}</span>
    <div class="plat-number">
      <span>{{ noteItem.plateNumber | plateFormat}}</span>
    </div>
  </li>
</template>

<script>
import defaultImg from '../../stylesheets/images/no-photo.png'

export default {
  data() {
    return {
      defaultImg: defaultImg
    }
  },
  props: {
    noteItem: {
      type: Object,
      required: true
      // desc
      /*
      customer_mobile: number 客户手机号
      customer_name: string 客户姓名
      plate_number: 客户车牌号数组
      */
    }
  },
  methods: {
    onItemClick() {
      this.$emit('on-item-click', this.noteItem.id)
    }
  },
  filters: {
    plateFormat(arr) {
      if (!Array.isArray(arr) || !arr.length) return '无开车到店记录'
      if (arr.length > 4) return `${arr.slice(0, 4).join('｜')}...`
      return arr.join('｜')
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.note-wrapper {
  height: 234/@w2;
  box-sizing: border-box;
  padding: 27/@w2 27/@w2 27/@w2 30/@w2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 20/@w2;
  font-size: 30/@w2;
  line-height: 42/@w2;
  color: #999999;
  letter-spacing: 0/@w2;
  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    &__name {
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>
